import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { SelectInput } from "fe-shared/src/components";
import { Errors } from "fe-shared/src/types/common";
import { RetreadingTransactionFormContent } from "../../../types";

import { getPeriodMonthOptions, yearOptions } from "../modules/helpers";
import styles from "../RetreadingTransactionFormDialog.module.scss";

interface Props {
  errors: Errors;
  values: RetreadingTransactionFormContent;
  updateValue: (key: string, value: unknown, isValidated?: boolean) => void;
}

const Period = ({ errors, values, updateValue }: Props) => {
  const { t } = useTranslation();

  const periodMonthOptions = useMemo(
    () => getPeriodMonthOptions(values.periodYear),
    [values.periodYear]
  );

  return (
    <div>
      <label htmlFor="period-month" className={styles.required}>
        {t("transactions.grid.createRetreadingTransaction.form.period")}
      </label>
      <div className={styles.periodSection}>
        <SelectInput
          id="period-month"
          placeholder={t(
            "transactions.grid.createRetreadingTransaction.form.monthPlaceholder"
          )}
          wrapperClassName={styles.selectWrapper}
          required
          isError={!!errors.periodMonth}
          errorText={errors.periodMonth}
          value={values.periodMonth}
          options={periodMonthOptions}
          onChange={(_, value) => updateValue("periodMonth", value)}
        />
        <SelectInput
          id="period-year"
          placeholder={t(
            "transactions.grid.createRetreadingTransaction.form.yearPlaceholder"
          )}
          wrapperClassName={styles.selectWrapper}
          required
          isError={!!errors.periodYear}
          errorText={errors.periodYear}
          value={values.periodYear}
          options={yearOptions}
          onChange={(_, value) => {
            updateValue("periodYear", value);
            updateValue("periodMonth", null);
          }}
        />
      </div>
    </div>
  );
};

export default Period;
